import { React, useState } from "react";
import Dashboard from "./Dashboard/Dashboard";
import "./MainMethodsContainer.css";
import { Switch, Route } from "react-router-dom";
import NewMethod from "./NewMethod/NewMethod";
import Data from "./NewMethod/Data/Data";
import Search from "./NewMethod/Search/Search";
import Features from "./NewMethod/Features/Features";
import Model from "./NewMethod/Model/Model";
import Classify from "./NewMethod/Model/Classify/Classify";
import Training from "./NewMethod/Training/Training";
import { useLocation } from "react-router-dom";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import Results from "./NewMethod/Results/Results";

const MainMethodsContainer = () => {
  let title = "Methods Dashboard";
  let configJSON = {
    selectedDB: 0,
    selectedDatasets: [],
    selectedClassifier: "",
  };
  const [dbState, setDBState] = useState(0);
  const [classifierState, setClassifierState] = useState("");
  const [datasetState, setDatasetState] = useState([]);

  const location = useLocation();
  switch (location.pathname) {
    case "/methods/new-method":
      title = "Build a New Method";
      break;
    case "/methods/new-method/data":
      title = "New Method / Data";
      break;
    case "/methods/new-method/search":
      title = "New Method / Data";
      break;
    case "/methods/new-method/features":
      title = "New Method / Features";
      break;
    case "/methods/new-method/model":
      title = "New Method / Model";
      break;
    case "/methods/new-method/model/classify":
      title = "New Method / Model / Classify";
      break;
    case "/methods/new-method/training":
      title = "New Method / Training";
      break;
    case "/methods/new-method/results":
      title = "New Method / Analysis";
      break;

    default:
      break;
  }

  const keepSelectedDB = (db) => {
    configJSON.selectedDB = db;
    setDBState(db);
    sessionStorage.setItem("db", db);
    //console.log(configJSON.selectedDB);
  };

  const keepSelectedClassifier = (classifier) => {
    configJSON.selectedClassifier = classifier;
    setClassifierState(classifier);
    sessionStorage.setItem("classifier", classifier);
  };

  const keepSelectedDatasets = (e) => {
    if (e.isSelected) {
      configJSON.selectedDatasets.push(e.data.name);
      //setDatasetState([...datasetState, e.data.name]);
    } else {
      const index = configJSON.selectedDatasets.indexOf(e.data.name);
      if (index > -1) {
        configJSON.selectedDatasets.splice(index, 1);
        //setDatasetState(datasetState.splice(index, 1));
      }
    }
    sessionStorage.setItem("dataset", e.data.name);
    //setDatasetState(configJSON.selectedDatasets);
  };

  return (
    <CSSTransition in={true} timeout={500} classNames="fade" appear={true}>
      <div className="methods">
        <h1>{title}</h1>
        <TransitionGroup>
          <CSSTransition key={location.key} classNames="fade" timeout={200}>
            <div className="method-container">
              <Switch location={location}>
                <Route
                  path="/methods"
                  exact
                  render={(props) => <Dashboard />}
                />

                <Route
                  path="/methods/new-method"
                  exact
                  render={(props) => <NewMethod />}
                />

                <Route
                  path="/methods/new-method/data"
                  render={(props) => <Data onSelect={keepSelectedDB} />}
                />

                <Route
                  path="/methods/new-method/search"
                  render={(props) => (
                    <Search
                      onSelect={keepSelectedDatasets}
                      rows={configJSON.selectedDatasets}
                      //rows={datasetState}
                      selectedDB={dbState}
                    />
                  )}
                />

                <Route
                  path="/methods/new-method/features"
                  render={(props) => <Features />}
                />

                <Route
                  exact
                  path="/methods/new-method/model"
                  render={(props) => <Model />}
                />

                <Route
                  path="/methods/new-method/model/classify"
                  render={(props) => (
                    <Classify onSelect={keepSelectedClassifier} />
                  )}
                />
                <Route
                  path="/methods/new-method/training"
                  render={(props) => (
                    <Training
                      selectedClassifier={classifierState}
                      selectedDatasets={datasetState}
                    />
                  )}
                />
                <Route
                  path="/methods/new-method/results"
                  render={(props) => (
                    <Results selectedClassifier={classifierState} />
                  )}
                />
              </Switch>
            </div>
          </CSSTransition>
        </TransitionGroup>
      </div>
    </CSSTransition>
  );
};

export default MainMethodsContainer;
